import React, { Component } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
export default class UpdateProfileABHA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      mobileNumber: "",
      mobileotp: ["", "", "", "", "", ""],
      emailId: "",
      showOtp: false,
      address: "",
      resendTimer: 60,
      resendEnabled: false,
      resendIntervalId: null,
    };
  }
  formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount =
      parseInt(sessionStorage.getItem("resendOtpUpdateMobileCount")) || 0;
  
    if (resendCount >= 2) {
      this.showToast("Resend OTP not working.","error");
      return;
    }
  
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
  
    fetch(configData.api_url + "C_Abhaverify/resendMobileOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // ✅ Check if there's an error in the details even when status is success
        if (data.details?.error?.message) {
           this.showToast(data.details.error.message,"error");
          return;
        }
  
        if (data.status === "success") {
          this.showToast(data.message, "success");
          sessionStorage.setItem("resendOtpUpdateMobileCount", resendCount + 1);
          clearInterval(this.state.resendIntervalId);
          this.startResendCountdown();
        } else {
          const errorMsg = data.message || "OTP resend failed. Please try again.";
           this.showToast(errorMsg, "error");
        }
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
         this.showToast("Something went wrong. Please try again later.","error");
      });
  };
    showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };

  handleOtpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      // allow only single digit or empty
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.mobileotp];
          newOtp[index] = val;
          return { mobileotp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput${index + 1}`].focus();
          }
        }
      );
    }
  };
  handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.mobileotp[index] && index > 0) {
      this[`otpInput${index - 1}`].focus();
    }
  };
  componentDidMount() {
    this.ResponseHandler();
    if (!sessionStorage.getItem("resendOtpUpdateMobileCount")) {
      sessionStorage.setItem("resendOtpUpdateMobileCount", "0");
    }
    this.startResendCountdown();
  }
  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpUpdateMobileCount:
        parseInt(sessionStorage.getItem("resendOtpUpdateMobileCount")) || 0,
      resendTimer: 60,
    }); // Start with 5 minutes
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 }; // Re-enable button after timer ends
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhanumber = data.detail.abhanumber;

          const abhaProfile = data.detail;
          if (abhaProfile)
            this.setState({ AbhaProfile: abhaProfile, abhanumber: abhanumber });
          else {
            window.location = "/consent";
          }
        }
      });
  };
  HandleMobileClick = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mobileNumber: fieldValue });
  };
  HandleAddressUpdate = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ address: fieldValue });
  };
  HandleAddressSumbit = (e) => {
    const { address } = this.state;
    const trimmedAddress = address.trim();

    if (!trimmedAddress) {
      this.showToast("Postal address is required.", "error");
      return;
    }
    if (trimmedAddress.length < 5) {
      this.showToast(
        "Postal address must be at least 5 characters long.",
        "error"
      );
      return;
    }
    // eslint-disable-next-line no-useless-escape
    const validAddressRegex = /^[A-Za-z0-9\s/\-&,.\u0900-\u097F]+$/;
    if (!validAddressRegex.test(trimmedAddress)) {
      this.showToast("Postal address contains invalid characters.", "error");
      return;
    }
    var formData = new FormData();
    formData.append("address", this.state.address);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    fetch(configData.api_url + "C_Abhaverify/updatepostalAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
      });
  };
  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  HandleMobileUpdate = (e) => {
    const { mobileNumber } = this.state;
    if (mobileNumber.trim() === "") {
      this.showToast("Mobile number is required.", "error");
      return;
    }
    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(mobileNumber)) {
      this.showToast(
        "Mobile Number must be 10 digits long and contain only numbers.",
        "error"
      );
      return;
    }
    var formData = new FormData();

    formData.append("mobileNumber", mobileNumber);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    fetch(configData.api_url + "C_Abhaverify/updateMobileinAbha", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          if (data.verifyMobile) {
            sessionStorage.setItem("mobile", this.state.mobile);
            this.setState({
              shownext: true,
            });
          }
        } else {
          const errorMsg = data.message || "Mobile update failed.";
           this.showToast(errorMsg);
        }
      });
  };

  HandleEmailUpdate = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ emailId: fieldValue });
  };
  HandleEmailSumbit = (e) => {
    const { emailId } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailId.trim()) {
      this.showToast("Email cannot be empty.");
      return;
    }

    if (!emailRegex.test(emailId)) {
      this.showToast("Please enter a valid email address.");
      return;
    }
    this.showToast(`Email submitted successfully: ${emailId}`);

    var formData = new FormData();
    formData.append("emailId", emailId);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    fetch(configData.api_url + "C_Abhaverify/updateEmailinAbha", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
      });
  };
  handleOtpVerification = (e) => {
    e.preventDefault();
    const mobileotp = this.state.mobileotp.join("");

    sessionStorage.setItem("mobileNumber", this.state.mobileNumber);
    var formData = new FormData();

    formData.append("mobileotp", mobileotp);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    this.setState({ resendButtonVisible: true });
    fetch(configData.api_url + "C_Abhaverify/submitMobileOtpinAbha", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("mobileNumber", this.state.mobileNumber);
          sessionStorage.setItem("resendOtpUpdateMobileCount", "");
          this.setState({
            resendOtpUpdateMobileCount: "",
          });
        }
      });
  };
  HandleBackClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/getAbhaProfile", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        sessionStorage.setItem(
          "abhaAddress",
          this.state.AbhaProfile.phrAddress
        );
        sessionStorage.setItem("aadharNumber", aadharNumber);
        sessionStorage.setItem("abhanumber", abhanumber);
        this.showToast(data.message);

        if (data.status === "success") {
          window.location.href = "/abhanumberprofile";
        }
      });
  };
  render() {
    const {
      mobileNumber,
      emailId,
      showOtp,
      address,
      resendEnabled,
      resendTimer,
    } = this.state;
    return (
      <div>
        <div className="row justify-content-md-center text-center updateProfileSection">
        <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Update Profile</h3>

          <div className="col-md-6 mt-4">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>
                  <b>Mobile Number</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="mobileNumber"
                  id="mobileNumber"
                  onChange={this.HandleMobileClick}
                  maxLength={10}
                  onKeyDown={this.onKeyDown}
                  className="form-control"
                  value={mobileNumber}
                />{" "}
                <Button
                  className="rounded-0 m-3"
                  onClick={this.HandleMobileUpdate}
                >
                  Update Mobile Number
                </Button>
              </Form.Group>
              <Form.Label>
                <b>Confirm OTP</b>
              </Form.Label>

              <i style={{ color: "blue" }}>{this.state.message}</i>

              <div
                className="d-flex gap-2"
                style={{ justifyContent: "center" }}
              >
                {this.state.mobileotp.map((digit, index) => (
                  <Form.Control
                    key={index}
                    type={this.state.showOtp ? "text" : "password"}
                    maxLength="1"
                    value={digit}
                    onChange={(e) => this.handleOtpChange(e, index)}
                    onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                    ref={(input) => (this[`otpInput${index}`] = input)}
                    style={{
                      textAlign: "center",
                    }}
                  />
                ))}

                <Button
                  variant="outline-secondary"
                  className={`rounded-0 bi ${
                    showOtp ? "bi-eye-slash" : "bi-eye"
                  }`}
                  onClick={() => this.setState({ showOtp: !showOtp })}
                />
              </div>
              <div as={Row} className="d-flex mt-3">
                <div className="col">
                  {parseInt(
                    sessionStorage.getItem("resendOtpUpdateMobileCount")
                  ) >= 2 ? (
                    <div style={{ color: "red", fontWeight: "bold" }}>
                    You’ve reached the maximum resend attempts.
                  </div>
                  ) : (
                    <>
                    <Button
                      className="rounded-0 m-1"
                      variant="warning"
                      onClick={this.ResendOTP}
                      disabled={!resendEnabled}
                    >
                      Resend OTP{" "}
                      {!resendEnabled && `in ${this.formatTime(resendTimer)}`}
                    </Button>
                    <div style={{ fontSize: "12px", color: "gray" }}>
               Resend OTP Send Only 2 Times in a Session You have used &nbsp;{" "}
                {sessionStorage.getItem("resendOtpUpdateMobileCount")} out of 2.
              </div>
                    </>
                  )}
                </div>
                <div className="col text-end">
                  <Button
                    className="rounded-0 m-1"
                    onClick={this.handleOtpVerification}
                  >
                    Verify OTP
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center text-center">
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Label>
                <b>Email Update</b>
              </Form.Label>
              <Form.Control
                type="text"
                name="emailId"
                id="emailId"
                onChange={this.HandleEmailUpdate}
                className="form-control"
                value={emailId}
              />

              <Button
                className="rounded-0 mt-3"
                onClick={this.HandleEmailSumbit}
              >
                Update Email-ID
              </Button>
            </div>
          </div>
        </div>
        <div className="row justify-content-md-center text-center">
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Label>
                <b>Address Update</b>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                id="address"
                onChange={this.HandleAddressUpdate}
                className="form-control"
                value={address}
              />{" "}
              <Button
                className="rounded-0 m-3"
                onClick={this.HandleAddressSumbit}
              >
                Address Update
              </Button>
            </div>
          </div>
        </div>

        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
          <div className="col">
            <Button className="rounded-0 m-1" onClick={this.HandleBackClick}>
              Back
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
